import {ApiClient} from '@hconnect/apiclient'
import {useMutation, type UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {SubmitSchedule} from '../api'

type Variables = {
  plantCode: string
  scheduleId: number
  updatedById: string
}

export const useSubmitScheduleMutation = (
  options?: Omit<UseMutationOptions<SubmitSchedule, AxiosError, Variables>, 'mutationFn'>
) =>
  useMutation<SubmitSchedule, AxiosError, Variables>({
    ...options,
    mutationFn: async ({scheduleId, plantCode, updatedById}) => {
      const response = await ApiClient.axiosInstance.post<SubmitSchedule>(
        '/electricity',
        {},
        {params: {plantCode, scheduleId, updatedBy: updatedById}}
      )
      return response.data
    }
  })
